module.exports = __webpack_public_path__ + "static/media/cc-icon-site-white.87180bed.svg";